<template lang="pug">
.reain-page
    el-dialog(
        :modal='false',
        title="移动端模拟器",
        :visible.sync="dialogVisible2",
        width='40%'
    )
        .phone-container(v-if='dialogVisible2')
            iframe(
                :src='"/phone2.html?id=" + currentId',
                width="100%",
                height="100%",
                frameborder="0"
            )
    el-dialog(
        title="新增教程",
        :visible.sync="dialogVisible",
        width='40%',
        @close='resetItem'
    )
        el-form(
            ref='form',
            :model='newItem',
            label-width='80px',
            size='medium'
        )
            el-form-item(label='教程名称')
                el-input(v-model='newItem.name')
        span(slot="footer")
            el-button(@click='dialogVisible=false', size='small') 取消
            el-button(type='primary', size='small', @click='confirm') 创建
    el-drawer(
        :visible.sync="drawer",
        direction="rtl",
        size='36%'
    )
        .title(slot='title') 培训教程
        .inner
            el-button(type='primary', @click='updateItem', size='small') 保存
            el-tabs(v-model='activeName', style='margin-bottom: 20px;')
                el-tab-pane(
                    v-for='item in activeList',
                    :key='item',
                    :name='item',
                    :label='item',
                    @click='activeName = item'
                )
            .drawer-item(v-show='activeName === "基本信息"')
                el-form(
                    ref='form',
                    :model='current',
                    label-width='80px',
                    size='medium',
                    label-position='left',
                    style='padding: 0 20px;'
                )
                    el-form-item(label='教程名称')
                        el-input(v-model='current.name')
                    el-form-item(label='疾病类型')
                        el-select(
                            v-model='current.diseaseType'
                        )
                            el-option(
                                v-for='item in diseaseListData',
                                :key='item.suborderCode',
                                :label='item.suborderName',
                                :value="item.suborderName"
                            )
                    el-form-item(label='管理状态')
                        el-radio-group(v-model="current.status", size="small")
                            el-radio-button(label='1') 新建
                    el-form-item(label='可用状态')
                        el-radio-group(v-model="current.available", size="small")
                            el-radio-button(label='0') 停用
                            el-radio-button(label='1') 启用
                    el-form-item(label='归属类型')
                        el-radio-group(v-model="current.scope", size="small")
                            el-radio-button(label='1') 公域
                            el-radio-button(label='2') 私域
                    el-form-item(label='特征标签')
                        el-input(v-model='current.tag')
                    el-form-item(label='教程说明')
                        el-input(type='textarea', :row='2', v-model='current.description')
            .drawer-item(v-show='activeName === "内容管理"', style='padding: 0 20px;')
                el-form(
                    ref='form',
                    :model='current',
                    label-width='80px',
                    size='medium',
                    label-position='left',
                )
                    el-form-item(label='教程名称')
                        span {{current.name}}
                    el-form-item(label='内容简介')
                        el-input(type='textarea', :row='2', v-model='current.description')
                    el-form-item(label='配图')
                        el-upload.uploader(
                            :action="uploadImageUrl",
                            :show-file-list="false",
                            :on-success="handleSuccess",
                            :before-upload="beforeUpload",
                            :data="{path:'dsicm-reain'}"
                        )
                            img.pic(v-if="current.image", :src="current.image")
                            i.el-icon-plus.uploader-icon(v-else)
                    el-form-item(label='章节目录', style='margin-bottom: 10px;')
                        el-button(type='primary', style='float: right;', size='small', @click='goToDetail') 编辑章节
                BaseTable(
                    :cell-style="{padding: '0'}"
                    :row-style="{height:'20px'}"
                    size="mini"
                    border
                    stripe
                    :data="childData"
                    :column="reainChildConfig"
                    :auto-scroll="true"
                )
            //- .drawer-item(v-show='activeName === "分享设置"')
    .top
        el-button( type='primary', size='mini', @click='addItem') 新增教程
    el-form(
        ref='form',
        :model='listQuery',
        label-width='85px',
        size='mini',
        inline
    )
      el-form-item(label='')
          el-input(type='text', v-model='listQuery.searchContent' placeholder="请输入要搜索的内容" prefix-icon="el-icon-search" clearable)
      el-form-item(label='归属类型：')
          el-select(
              v-model='listQuery.scope'
              clearable
          )
              el-option(
                  v-for='(item,index) in scopeList',
                  :key='index',
                  :label='item.label',
                  :value="item.value"
              )
      el-form-item(label='病种类型：', style='margin-bottom: 10px;')

          el-select(
              v-model='listQuery.diseaseType'
              clearable
          )
              el-option(
                  v-for='(item,index) in diseaseListData',
                  :key='index',
                  :label='item.suborderName',
                  :value="item.suborderName"
              )
      //- el-form-item(label='特征标签：', style='margin-bottom: 10px;')
      //-     el-select(
      //-         v-model='listQuery.tag'
      //-     )
      //-         el-option(
      //-             v-for='item in tagList',
      //-             :key='item.suborderCode',
      //-             :label='item.suborderName',
      //-             :value="item.suborderName"
      //-         )
      el-form-item(label='创建时间：', style='margin-bottom: 10px;')
        el-date-picker(
          v-model="tiemList"
          type="daterange"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        )
      el-form-item
        el-button( type='primary', size='mini', @click='resetHandel') 重置
        el-button( type='primary', size='mini', @click='queryHandel') 搜索



    BaseTable(
        v-loading='loading',
        :cell-style="{padding: '0'}"
        :row-style="{height:'20px'}"
        size="mini"
        border
        stripe
        :data="tableData"
        :column="reainConfig"
        pagination
        :auto-scroll="true"
        :total="total"
        :page.sync="pageNum"
        :limit.sync="pageSize"
        @pagination="handlePageChange"
    )

</template>

<script>
import ToolConfig from './common/toolconfig'
import { api_get_disease_type } from '@/api/ManagementPlan'
import axios from 'axios'
import _ from 'lodash'
export default {
  mixins: [ToolConfig],
  data() {
    return {
      diseaseListData: [],
      scopeList: [
        {
          label: '公域',
          value: 1,
        },
        {
          label: '私域',
          value: 2,
        },
      ],
      tagList: [], //特征标签
      tiemList: [],
      diseaseListDataList: [{}],
      // 表格
      loading: false,
      tableData: [],
      total: 0,
      pageNum: 1,
      pageSize: 10,
      listQuery: {
        searchContent: '', //查询内容关键字
        beginTime: '',
        endTime: '',
        diseaseType: '', //病种类型
        scope: '', //归属类型
        // tag: '', //标签x
        size: 10,
        current: 1,
      },
      current: {}, // 当前教程
      childData: [], // 当前教程所有章节列表
      drawer: false,
      dialogVisible: false,
      newItem: {
        // 新建教程数据
        name: '',
      },
      activeName: '基本信息',
      activeList: [
        '基本信息',
        '内容管理',
        // '分享设置'
      ],
      uploadImageUrl: '/api/dsicm-contact-platform/feign/file/upload',
      dialogVisible2: false,
      currentId: 0, // 预览id
    }
  },
  mounted() {
    this.getData()
    this.getDisease()
  },
  methods: {
    /**
     * @description: 重置
     * @event:
     * @param {*}
     * @return {*}
     */
    resetHandel() {
      this.tiemList = []
      this.listQuery = this.$options.data().listQuery
      this.getData()
    },
    /**
     * @description: 查询
     * @event:
     * @param {*}
     * @return {*}
     */
    queryHandel() {
      this.listQuery.size = 10
      this.listQuery.current = 1
      if (Array.isArray(this.tiemList) && this.tiemList.length > 1) {
        this.listQuery.endTime =  this.$machiningTime(this.tiemList[1])
        this.listQuery.beginTime = this.tiemList[0]
      } else {
        this.listQuery.endTime = ''
        this.listQuery.beginTime = ''
      }

      this.getData()
    },
    getDisease() {
      api_get_disease_type().then((res) => {
        if (res.code == 0) {
          this.diseaseListData = res.data
        }
      })
    },
    getData() {
      // 获取教程
      this.loading = true
      axios
        .get('admin/train-course/page', {
          params: {
            ...this.listQuery,
          },
        })
        .then((resp) => {
          if(resp.data.code == 0){
            let data = resp.data.data
            this.tableData = data.records || []
            this.total = data.total
          }else{
            this.$message.error(resp.message);
          }
        })
        .finally(() => {
          this.loading = false
        })
        .catch(e => {
          this.loading = false
        })
    },
    getDetailData() {
      // 获取章节
      axios
        .get('admin/train-chapter/courseId', {
          params: {
            courseId: this.current.id,
          },
        })
        .then((resp) => {
          let data = resp.data
          this.childData = data.data || []
        })
    },
    showItem(scope) {
      this.current = _.cloneDeep(scope.row)
      this.current.scope = this.current.scope || '1'
      this.getDetailData()
      this.drawer = true
    },
    deleteItem(scope) {
      this.$confirm('是否要删除该教程', '确认信息', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        customClass: 'message-confirm-style'
      }).then(() => {
        axios.delete('admin/train-course/' + scope.row.id).then((resp) => {
          let data = resp.data
          if (data.success) {
            this.$message.success('删除成功')
            this.getData()
          }
        })
      })
    },
    updateItem() {
      let obj = {
        name: this.current.name,
        diseaseType: this.current.diseaseType,
        status: this.current.status,
        available: this.current.available,
        scope: this.current.scope,
        tag: this.current.tag,
        description: this.current.description,
        image: this.current.image,
        id: this.current.id,
      }
      axios.put('admin/train-course', obj).then((resp) => {
        let data = resp.data
        if (data.success) {
          this.$message.success('编辑成功')
          if (this.activeName === '基本信息') {
            this.activeName = '内容管理'
          } else {
            this.drawer = false
          }
          this.getData()
        }
      })
    },
    addItem() {
      this.dialogVisible = true
    },
    resetItem() {
      this.newItem.name = ''
    },
    confirm() {
      if (this.newItem.name == '') {
        this.$message.error('请填写教程名称后创建')
        return false
      } else {
        axios.post('admin/train-course', this.newItem).then((resp) => {
          let data = resp.data
          if (data.success) {
            this.$message.success('新增成功')
            this.dialogVisible = false
            this.getData()
          }
        })
      }
    },
    handlePageChange() {
      this.getData()
    },
    goToDetail() {
      this.drawer = false
      this.$router.push({
        path: '/ToolMaintenance/reainDetail',
        query: {
          id: this.current.id,
        },
      })
    },
    preview(scope) {
      this.currentId = scope.row.id
      this.dialogVisible2 = true
    },
    handleSuccess(res) {
      let url = process.env.VUE_APP_OSS_URL + res.data
      this.current.image = url
    },
    beforeUpload() {},
  },
  components: {},
}
</script>


<style lang="less" scoped>
.reain-page {
  .phone-container {
    width: 414px;
    height: 736px;
    border: 1px solid #999;
    margin: 0 auto;
  }
  /deep/ .el-drawer__body {
    height: calc(100% - 53px);
  }
  /deep/ .el-drawer__header {
    margin-bottom: 10px;
  }
  .title {
    color: #222;
    font-size: 18px;
    font-weight: 600;
  }
  .inner {
    padding: 0 20px;
    padding-bottom: 50px;
    height: 100%;
    overflow: auto;
    .drawer-item {
      .info-wrap {
        padding: 0 20px;
        display: flex;
        margin-bottom: 10px;
        line-height: 20px;
        font-size: 14px;
        color: #606266;
        span:first-child {
          display: block;
          width: 180px;
        }
        span:last-child {
          flex: 1;
        }
      }
    }
    .uploader {
      /deep/ .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      /deep/ .el-upload:hover {
        border-color: #409eff;
      }
      .uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 100px;
        height: 100px;
        line-height: 100px;
        text-align: center;
      }
      .pic {
        width: 100px;
        height: 100px;
        display: block;
      }
    }
  }
  .top {
    width: 100%;
    text-align: right;
    margin-bottom: 20px;
  }
}
</style>
